import { mediaQuery, strlIsInView } from '../helpers';

export default class PageIndex {
	constructor(root) {
		this.root = root;
		this.anchorSections = document.querySelectorAll('.article-section');
		this.inView = 0;

		document.addEventListener(
			'scroll',
			() => {
				this.deriveScrolledTitle(this.anchorSections);
				this.setActiveState(this.inView);
			},
			{ passive: true }
		);
	}

	deriveScrolledTitle(anchorSections) {
		for (let i = 0; i < anchorSections.length; i++) {
			const section = anchorSections[i];

			const inView = strlIsInView(section, mediaQuery('sm') ? -150 : 0);

			if (inView) {
				this.inView = i;
				break;
			}
		}
	}

	setActiveState(i) {
		const anchors = this.root?.querySelectorAll('a');

		anchors.forEach((anchor, j) => {
			anchor.classList.toggle('active', i === j);
		});
	}
}
